import { Blockchain } from "@anaconda/core/blockchain/types"

export const getSupportedBlockchains = (): [Blockchain, ...Blockchain[]] => [
  Blockchain.ETHEREUM,
  Blockchain.ROBINHOOD,
  Blockchain.BASE,
  Blockchain.CAMP,
  Blockchain.RARI,
  Blockchain.SOMNIA,
  Blockchain.HYPEREVM,
  Blockchain.ARENAZ,
  Blockchain.LIGHTLINK,
  Blockchain.ELECTRONEUM,
  Blockchain.MOONBEAM,
  Blockchain.POLYGON,
  Blockchain.APECHAIN,
  Blockchain.ZKCANDY,
  Blockchain.ETHERLINK,
  Blockchain.ZILLIQA,
  Blockchain.SHAPE,
  Blockchain.MATCH,
  Blockchain.TELOS,
  Blockchain.FRAXTAL,
  Blockchain.HEDERAEVM,
  Blockchain.INJECTIVE,
  Blockchain.MEGAETH,
  Blockchain.MEGAETHTESTNET,
  Blockchain.INJECTIVETESTNET,
  Blockchain.BLOCKCHAINKEK,
  Blockchain.MEGAETHTESTNETV2,
  Blockchain.SOLANA,
]

export const getRoutableBlockchains = (): [Blockchain, ...Blockchain[]] => [
  ...getSupportedBlockchains(),
]
